import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Settings, Loader2 } from 'lucide-react';

interface ProcessorInfo {
  name: string;
  description: string;
  version: string;
  supported_formats: string[];
  parameters: Record<string, any>;
}

interface ProcessorSelectorProps {
  processors: Record<string, ProcessorInfo>;
  selectedProcessor: string;
  onProcessorChange: (processorName: string) => void;
  isLoading: boolean;
}

export const ProcessorSelector: React.FC<ProcessorSelectorProps> = ({
  processors,
  selectedProcessor,
  onProcessorChange,
  isLoading
}) => {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="w-5 h-5" />
            处理器选择
          </CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center py-8">
          <div className="flex items-center gap-2 text-gray-500">
            <Loader2 className="w-4 h-4 animate-spin" />
            加载处理器中...
          </div>
        </CardContent>
      </Card>
    );
  }

  const processorList = Object.entries(processors);

  if (processorList.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="w-5 h-5" />
            处理器选择
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center py-8">
          <p className="text-gray-500">没有可用的处理器</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="w-5 h-5" />
          处理器选择
        </CardTitle>
        <CardDescription>
          选择要使用的图片处理器
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {processorList.map(([name, info]) => (
            <div
              key={name}
              className={`p-4 border rounded-lg cursor-pointer transition-colors ${
                selectedProcessor === name
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              onClick={() => onProcessorChange(name)}
            >
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <h3 className="font-medium text-sm break-words">{info.name}</h3>
                  <span className="text-xs text-gray-500 flex-shrink-0">v{info.version}</span>
                </div>
                <p className="text-xs text-gray-600 line-clamp-2 break-words">
                  {info.description}
                </p>
                <div className="text-xs text-gray-500 break-words">
                  支持: {info.supported_formats.join(', ')}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};